import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './vrs-confirm-dialog.component.html',
  styleUrls: ['./vrs-confirm-dialog.component.scss'],
})
export class VrsConfirmDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<VrsConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { sites: string[] }
  ) {}

  onCancel(): void {
    this.dialogRef.close(false); // Pass false for cancellation
  }

  onProceed(): void {
    this.dialogRef.close(true); // Pass true for proceeding
  }
}